export default "__VITE_ASSET__9cc13107__"